import { MappedPrice as Price } from '../../../../components/price/price.desktop';
import price from './price';

const configurePrice = price(Price);

export default configurePrice;
